import { tns } from "tiny-slider";

export const worldCredentialsSlider = () => {
    const worldCredentialsSliderContainer = document.getElementById('world-credentials-slider');
    if (worldCredentialsSliderContainer) {
        tns({
            responsive: {
                0: {
                    items: 1,
                    fixedWidth: 0
                },
                639: {
                    fixedWidth: 150
                },
            },
            container: worldCredentialsSliderContainer,
            startIndex: 0,
            loop: true,
            fixedWidth: 150,
            controlsContainer: worldCredentialsSliderContainer.parentElement.nextElementSibling,
            nav: false,
            swipeAngle: false,
            speed: 400
        })
    }
}
